import { render } from "./jmdetail.vue?vue&type=template&id=73ba78d6&scoped=true"
import script from "./jmdetail.vue?vue&type=script&lang=js"
export * from "./jmdetail.vue?vue&type=script&lang=js"

import "./jmdetail.vue?vue&type=style&index=0&id=73ba78d6&lang=scss&scoped=true"
import "./jmdetail.vue?vue&type=style&index=1&id=73ba78d6&lang=css"

import exportComponent from "D:\\workCode\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73ba78d6"]])

export default __exports__